export enum ComponentVariantEnum {
  Dark = 'dark',
  Light = 'light',
}
